import type { PropsWithChildren } from 'react';

import { Card } from 'src/app/components/Elements/Card';

import { SpacedOutCardItem } from './styles';

export const CalloutBox = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <Card aria-disabled={true}>
      <SpacedOutCardItem inactive={true}>{children}</SpacedOutCardItem>
    </Card>
  );
};
